import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import berita from '../views/Berita/berita.vue'
import isiBerita from '../views/Berita/isiBerita.vue'
import tugasPokok from '../views/profil/tugasPokok.vue'
import strukturOrganisasi from '../views/profil/strukturOrganisasi.vue'
import visiMisi from '../views/profil/visiMisi.vue'
import dataPegawai from '../views/profil/datapegawai.vue'
import bidangPerencanaan from '../views/unitKerja/bidangPerencanaan.vue'
import bidangPemerintahan from '../views/unitKerja/bidangPemerintahan.vue'
import bidangInfrastruktur from '../views/unitKerja/bidangInfrastruktur.vue'
import bidangPerekonomian from '../views/unitKerja/bidangPerekonomian.vue'
import sekretariat from '../views/unitKerja/sekretariat.vue'
import rpjmn from '../views/dokumen/rpjmn.vue'
import rpjmd from '../views/dokumen/rpjmd.vue'
import rkpd from '../views/dokumen/rkpd.vue'
import foto from '../views/galeri/foto.vue'
import video from '../views/galeri/video.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/berita',
    name: 'berita',
    component: berita
  },
  {
    path: '/isiBerita',
    name: 'isiBerita',
    component: isiBerita
  },
  {
    path: '/dataPegawai',
    name: 'dataPegawai',
    component: dataPegawai
  },
  {
    path: '/strukturOrganisasi',
    name: 'strukturOrganisasi',
    component: strukturOrganisasi
  },
  {
    path: '/tugasPokok',
    name: 'tugasPokok',
    component: tugasPokok
  },
  {
    path: '/visiMisi',
    name: 'visiMisi',
    component: visiMisi
  },
  {
    path: '/bidangPerencanaan',
    name: 'bidanbidangPerencanaangEkraf',
    component: bidangPerencanaan
  },
  {
    path: '/bidangPemerintahan',
    name: 'bidangPemerintahan',
    component: bidangPemerintahan
  },
  {
    path: '/bidangInfrastruktur',
    name: 'bidangInfrastruktur',
    component: bidangInfrastruktur
  },
  {
    path: '/bidangPerekonomian',
    name: 'bidangPerekonomian',
    component: bidangPerekonomian
  },
  {
    path: '/sekretariat',
    name: 'sekretariat',
    component: sekretariat
  },
  {
    path: '/rpjmn',
    name: 'rpjmn',
    component: rpjmn
  },
  {
    path: '/rpjmd',
    name: 'rpjmd',
    component: rpjmd
  },
  {
    path: '/rkpd',
    name: 'rkpd',
    component: rkpd
  },
  {
    path: '/foto',
    name: 'foto',
    component: foto
  },
  {
    path: '/video',
    name: 'video',
    component: video
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
